// 🎵 Configuration Audio - Annonces, Playlists et Radio
// Gère les 3 modes du lecteur : Annonce, Playlist, Radio
// Utilisé dans : RadioPlayer.jsx

/**
 * Liste des annonces vocales (lecture au démarrage)
 * Placez vos fichiers MP3 dans : /public/sounds/vocals/
 */
export const VOCALS = [
  {
    id: 'casting-2026',
    title: 'Casting Rock\'In Agde 2026',
    artist: 'Rock\'In Agde',
    file: '/sounds/vocals/vocal-casting-2026.mp3',
    duration: null // Sera détecté automatiquement
  }
  // Ajouter d'autres annonces ici :
  // {
  //   id: 'annonce-billetterie',
  //   title: 'Billetterie ouverte',
  //   artist: 'Rock\'In Agde',
  //   file: '/sounds/vocals/vocal-billetterie.mp3'
  // }
]

/**
 * Playlist musicale (morceaux en boucle)
 * Placez vos fichiers MP3 dans : /public/sounds/musics/
 */
export const MUSICS = [
  {
    id: 'fallin-v1',
    title: 'FALLIN\' IN ROCKIN\'AGDE (v1)',
    artist: 'by MIKI (Domelvia Production)',
    file: '/sounds/musics/fallin-v1.mp3',
    duration: null
  },
  {
    id: 'fallin-v2',
    title: 'FALLIN\' IN ROCKIN\'AGDE (v2)',
    artist: 'by MIKI (Domelvia Production)',
    file: '/sounds/musics/fallin-v2.mp3',
    duration: null
  }
]

/**
 * Configuration du stream radio
 */
export const RADIO_CONFIG = {
  id: 'rtl2-littoral',
  title: 'RTL2 Littoral',
  artist: 'Le Son Pop-Rock',
  stream: 'https://rtl2littoral.ice.infomaniak.ch/rtl2littoral-128.aac?ua=RTL2%20LITTORAL%20Request%20Method',
  isLive: true
}

/**
 * Modes de lecture disponibles
 */
export const PLAYER_MODES = {
  ANNONCE: 'annonce',
  PLAYLIST: 'playlist',
  RADIO: 'radio'
}

/**
 * Configuration de la séquence de lecture par défaut
 * Au démarrage : Annonce → Playlist → Radio
 */
export const AUTO_SEQUENCE = {
  enabled: true, // Active/désactive la lecture séquentielle
  startMode: PLAYER_MODES.ANNONCE,
  sequence: [
    PLAYER_MODES.ANNONCE,   // 1. Joue toutes les annonces
    PLAYER_MODES.PLAYLIST,  // 2. Puis toute la playlist
    PLAYER_MODES.RADIO      // 3. Puis reste sur la radio
  ]
}
